module.exports = __webpack_public_path__ + "9a790b6c89dc84a46e60a66f46d58b4c.pdf";